import { IconWrapper } from '../runtime';
export default IconWrapper('template-library', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.87306 6.6711C2.24438 6.93192 1 8.34345 1 10.0456C1 11.9332 2.53015 13.4633 4.41769 13.4633C6.30523 13.4633 7.83539 11.9332 7.83539 10.0456C7.83539 9.84521 7.81814 9.64883 7.78504 9.45787L4.96808 8.38033C4.25033 8.10578 3.82446 7.39978 3.87306 6.6711Z",
      "fill": "#FDBC39"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.9194 7.30192C11.2343 6.67217 12.133 6.67217 12.4479 7.30192L14.9103 12.2268C15.1944 12.7949 14.7813 13.4633 14.1461 13.4633H9.22125C8.58609 13.4633 8.17298 12.7949 8.45703 12.2268L10.9194 7.30192Z",
      "fill": "#F45151"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.48428 1.80659C7.04354 1.638 6.54958 1.85862 6.38099 2.29936L4.78221 6.47898C4.61362 6.91972 4.83424 7.41368 5.27498 7.58227L9.09373 9.04301L10.1553 6.91982C10.4548 6.32085 11.0184 6.00673 11.5948 5.97745L12.1567 4.50866C12.3253 4.06792 12.1046 3.57396 11.6639 3.40537L7.48428 1.80659Z",
      "fill": "#0A6CFF"
    }
  })])]);
});